import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "transition-picker" }
const _hoisted_2 = { class: "transition-picker__container" }
const _hoisted_3 = { class: "selected-transition" }
const _hoisted_4 = {
  key: 3,
  class: "icon"
}
const _hoisted_5 = {
  key: 0,
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_6 = { class: "dropdown-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "dropdown-item item-group-heading" }
const _hoisted_10 = { class: "heading-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "add-item" }
const _hoisted_13 = { class: "add-path" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_16 = { class: "dropdown-item item-group-heading" }
const _hoisted_17 = { class: "heading-container" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "add-item" }
const _hoisted_20 = { class: "add-flow" }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = {
  key: 0,
  class: "dropdown-divider"
}
const _hoisted_23 = { class: "dropdown-item item-group-heading" }
const _hoisted_24 = { class: "heading-container" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "goto-button"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "icon" }

import { PathViewModel } from '@/features/bots/models/designer';
import { dropDownHelper } from '@/shared/components/dropDownMenu/dropDownHelper';
import { ADD_PATH, SET_CURRENT_PATH } from '@/store/bot-designer/paths/mutationTypes';
import { TransitionViewModel } from '../../models/designer/transitionViewModel';
import { TransitionType } from '@/features/bots/models/designer/transitionType';
import PathIcon from 'vue-material-design-icons/CallSplit.vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import { nanoid } from 'nanoid';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import Toast from '@/shared/services/toast';
import AddFlowModal from '@/shared/components/AddFlowModal.vue';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import { TransitionPickerOption } from '../../models/designer/transitionPickerOption';
import { TransitionPickerConfig } from '../../models/designer/transitionPickerConfig';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import { LOAD_ANSWERS } from '@/store/answers/actionTypes';
import { AnswerListItemViewModel } from '../../models/answers/answerListItemViewModel';
import { computed, nextTick, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import AnswerIcon from '@shared/icons/AnswerIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TransitionPicker',
  props: {
  transition: {
    type: Object as PropType<TransitionViewModel>,
  },
  fixed: {
    type: Boolean,
    default: false,
  },
  showNoneTransition: {
    type: Boolean,
    default: true,
  },
},
  emits: ["transition-selected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();

const store = useStore();
const transitionPickerConfigForAnswer = computed<TransitionPickerConfig>(
  () => store.getters.transitionPickerConfigForAnswer,
);
const transitionPickerConfigForFlow = computed<TransitionPickerConfig>(
  () => store.getters.transitionPickerConfigForFlow,
);
const transitionPickerFixedConfig = computed<TransitionPickerConfig>(() => store.getters.transitionPickerFixedConfig);
const isTransitionPayloadInvalid = (payload: string) =>
  computed(() => store.getters.isTransitionPayloadInvalid(payload));

const loadFlows = (forceLoad = false): Promise<FlowListItemViewModel[]> => store.dispatch(LOAD_FLOWS, forceLoad);
const loadAnswers = (doLoad = false): Promise<AnswerListItemViewModel[]> => store.dispatch(LOAD_ANSWERS, doLoad);

const setCurrentPath = (id: string) => store.commit(SET_CURRENT_PATH, id);
const addPath = (path: PathViewModel) => store.commit(ADD_PATH, path);

const selectedLabel = ref('');
const isOpen = ref(false);
const isUp = ref(false);
const selectedTransition = ref<TransitionViewModel>({} as TransitionViewModel);
const showModal = ref(false);
const loaded = ref(false);

const pathOptions = computed(() =>
  options.value.filter((x) => x.type === TransitionType.Path).sort((a, b) => a.name.localeCompare(b.name)),
);
const flowOptions = computed(() =>
  options.value.filter((x) => x.type === TransitionType.Flow).sort((a, b) => a.name.localeCompare(b.name)),
);
const answerOptions = computed(() =>
  options.value.filter((x) => x.type === TransitionType.Answer).sort((a, b) => a.name.localeCompare(b.name)),
);
const noneTransition = computed(() => options.value.find((x) => x.type === TransitionType.None));
const options = computed(() => config.value?.options || []);
const canAddNewFlow = computed(() => config.value.currentStatus !== FlowStatus.Live);
const isPathOptionsVisible = computed(
  () => (pathOptions.value && pathOptions.value.length > 0) || config.value.allowAddPath,
);
const isFlowOptionsVisible = computed(() => (flowOptions.value && flowOptions.value.length > 0) || canAddNewFlow.value);
const isAnswerOptionsVisible = computed(() => answerOptions.value && answerOptions.value.length > 0);
const isGoToButtonDisabled = computed(() => !loaded.value || !isTransitionValid.value);
const isTransitionValid = computed(
  () => props.transition?.payload && !isTransitionPayloadInvalid(props.transition.payload).value,
);
const config = computed<TransitionPickerConfig>(() => {
  if (props.fixed) {
    return transitionPickerFixedConfig.value;
  }
  if (isOnAnswersPage()) {
    return transitionPickerConfigForAnswer.value;
  }
  return transitionPickerConfigForFlow.value;
});

watch(
  () => props.transition,
  (value: TransitionViewModel) => (selectedTransition.value = value || ({} as TransitionViewModel)),
  { immediate: true },
);
onMounted(() => loadFlowsAndAnswers());

function getSelectedOptionName(): string {
  if (!loaded.value) {
    return '';
  }
  if (selectedTransition.value?.payload) {
    if (isTransitionPayloadInvalid(selectedTransition.value.payload).value) {
      return 'Invalid transition';
    }
  }
  if (!selectedLabel.value) {
    selectedLabel.value = options.value.find((x) => x.id === selectedTransition.value?.payload)?.name || '';
  }
  if (!selectedLabel.value) {
    return 'Choose a transition';
  }

  return selectedLabel.value;
}

function closePicker() {
  isOpen.value = false;
  isUp.value = false;
}

function togglePicker() {
  // don't allow opening the menu/choosing a path if the picker should be 'fixed'
  if (props.fixed) {
    return;
  }

  isOpen.value = !isOpen.value;

  nextTick(() => (isUp.value = dropDownHelper.isDropDownUp()));
}

function goToTransition() {
  if (typeof selectedTransition.value.payload === 'string') {
    if (selectedTransition.value.type === TransitionType.Path) {
      setCurrentPath(selectedTransition.value.payload);
    } else if (selectedTransition.value.type === TransitionType.Flow) {
      goToFlow();
    } else if (selectedTransition.value.type === TransitionType.Answer) {
      goToAnswer();
    }
  }
}

function chooseOption(option: TransitionPickerOption) {
  selectedLabel.value = option.name;
  chooseTransition(option.id, option.type);
  closePicker();
}

function chooseFlow(flow: FlowListItemViewModel) {
  selectedLabel.value = flow.name;
  chooseTransition(flow.id, TransitionType.Flow);
}

function chooseTransition(id: string, transitionType: TransitionType) {
  selectedTransition.value = {
    payload: id,
    type: transitionType,
  } as TransitionViewModel;

  emit('transition-selected', selectedTransition.value);
}

function isTypeSelected(type: TransitionType) {
  return selectedTransition.value?.type === type;
}

async function goToFlow() {
  try {
    if (selectedTransition.value && selectedTransition.value.payload) {
      router.push({
        name: 'bots-flow-designer',
        params: { flowId: selectedTransition.value.payload },
      });
    } else {
      Toast.showError("Can't find Flow");
    }
  } catch (err: any) {
    Toast.showError(err.message);
  }
}

async function goToAnswer() {
  try {
    if (selectedTransition.value && selectedTransition.value.payload) {
      router.push({
        name: 'bots-answer-editor',
        params: { id: selectedTransition.value.payload },
      });
    }
  } catch (err: any) {
    Toast.showError(err.message);
  }
}

function addNewPath() {
  const newPath = {
    id: `path-${nanoid(7)}`,
    name: `New Path`,
    states: [],
  } as PathViewModel;

  addPath(newPath);

  selectedLabel.value = newPath.name;

  selectedTransition.value = {
    type: TransitionType.Path,
    payload: newPath.id,
  };
  emit('transition-selected', selectedTransition.value);
}

function isNoneChosen() {
  return props.transition && props.transition.type === TransitionType.None;
}

function isOnAnswersPage() {
  return getRouteName() === 'bots-answer-editor';
}

function getRouteName() {
  return router.currentRoute.value.name;
}

async function loadFlowsAndAnswers(): Promise<void> {
  loaded.value = false;
  try {
    await Promise.all([loadFlows(), loadAnswers()]);
  } catch (e: any) {
    Toast.showError(e.message);
  }
  loaded.value = true;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["dropdown", { 'is-active': isOpen.value, 'is-up': isUp.value }])
      }, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "dropdown-trigger",
          onClick: togglePicker
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["button", { fixed: __props.fixed, 'button--loading': !loaded.value }])
          }, [
            (loaded.value && isTypeSelected(2))
              ? (_openBlock(), _createBlock(PathIcon, {
                  key: 0,
                  class: "icon-1-3x selected-icon fa-flip-vertical path-icon"
                }))
              : _createCommentVNode("", true),
            (loaded.value && isTypeSelected(3))
              ? (_openBlock(), _createBlock(FlowIcon, {
                  key: 1,
                  class: "icon-1-3x selected-icon"
                }))
              : _createCommentVNode("", true),
            (loaded.value && isTypeSelected(4))
              ? (_openBlock(), _createBlock(AnswerIcon, {
                  key: 2,
                  class: "answers-icon selected-answer"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_3, _toDisplayString(getSelectedOptionName()), 1),
            (loaded.value && !__props.fixed)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _createVNode(_component_font_awesome_icon, { icon: "angle-down" })
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ])), [
          [_directive_click_away, closePicker]
        ]),
        (loaded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (noneTransition.value && __props.showNoneTransition)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (chooseOption(noneTransition.value)))
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "add-item" }, "None", -1)
                      ])),
                      _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1))
                    ]))
                  : _createCommentVNode("", true),
                (isPathOptionsVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(PathIcon, { class: "icon-1-5x dropdown-icons fa-flip-vertical path-icon" }),
                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "heading-with-icon" }, "Paths", -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: option.id,
                            onClick: ($event: any) => (chooseOption(option)),
                            class: "dropdown-item dropdown-child"
                          }, _toDisplayString(option.name), 9, _hoisted_11))
                        }), 128)),
                        _createElementVNode("a", {
                          class: "dropdown-item",
                          onClick: addNewPath
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, [
                              _createVNode(AddIcon, { class: "icon-1-3x" }),
                              _cache[7] || (_cache[7] = _createTextVNode(" Add new path "))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isFlowOptionsVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (isPathOptionsVisible.value)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(FlowIcon, { class: "icon-1-5x dropdown-icons" }),
                          _cache[8] || (_cache[8] = _createElementVNode("span", { class: "heading-with-icon" }, "Flows", -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: option.id,
                            onClick: ($event: any) => (chooseOption(option)),
                            class: "dropdown-item dropdown-child"
                          }, _toDisplayString(option.name), 9, _hoisted_18))
                        }), 128))
                      ]),
                      (canAddNewFlow.value)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            class: "dropdown-item",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = true))
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, [
                                _createVNode(AddIcon, { class: "icon-1-3x" }),
                                _cache[9] || (_cache[9] = _createTextVNode(" Add new flow "))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (isAnswerOptionsVisible.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      (isPathOptionsVisible.value || isFlowOptionsVisible.value)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_22))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          (loaded.value && isTypeSelected(4))
                            ? (_openBlock(), _createBlock(AnswerIcon, {
                                key: 0,
                                class: "answers-icon"
                              }))
                            : _createCommentVNode("", true),
                          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "answers-heading" }, "FAQs", -1))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerOptions.value, (option) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: option.id,
                            onClick: ($event: any) => (chooseOption(option)),
                            class: "dropdown-item dropdown-child"
                          }, _toDisplayString(option.name), 9, _hoisted_25))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (!isNoneChosen())
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (goToTransition())),
                disabled: isGoToButtonDisabled.value
              }, [
                _createElementVNode("span", _hoisted_28, [
                  _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
                ])
              ], 8, _hoisted_27)
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(AddFlowModal, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = false)),
          onFlowAdded: chooseFlow
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})